import { render, staticRenderFns } from "./QuizScreen.vue?vue&type=template&id=74ae04eb&scoped=true&"
import script from "./QuizScreen.vue?vue&type=script&lang=js&"
export * from "./QuizScreen.vue?vue&type=script&lang=js&"
import style0 from "./QuizScreen.vue?vue&type=style&index=0&id=74ae04eb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ae04eb",
  null
  
)

export default component.exports